import { makeStyles } from "@fluentui/react-components";

export const SignInHeaderNavStyles = makeStyles({
  main: {
    display: "flex",
    alignItems: "center",
    gap: "18px",
  },
  text: {
    fontFamily: "Segoe UI",
    fontSize: "13.78px",
    fontStyle: "normal",
    fontWeight: "regular",
    lineHeight: "18px",
  },
});
